import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { interaction_arrows_chevronDown } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import '../EyeCatcher/EyeCatcherPresentation.js';
import { EyeCatcherWrapper } from '../EyeCatcher/EyeCatcherWrapper.js';
import { HeadlinePresentation } from '../Headline/HeadlinePresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { ParagraphPresentation } from '../Paragraph/ParagraphPresentation.js';
import '../PictureBackground/PictureBackgroundPresentation.js';
import { PictureBackgroundWrapper } from '../PictureBackground/PictureBackgroundWrapper.js';
import { getThemeClass } from '../Theme/ThemePresentation.js';
import { hostClass } from './Stage.styles.js';

var defaultProps = {
  theme: "light",
  onScrollerClick: function onScrollerClick() {
    /* empty */
  }
};

var getFocalPoint = function getFocalPoint(backgroundImageFocalPoint, viewportSize) {
  if (backgroundImageFocalPoint) return backgroundImageFocalPoint; // values are given via prop

  if (["sm", "xs"].includes(viewportSize)) {
    return {
      offsetLeft: 50,
      offsetTop: 20
    }; // default small viewport
  }

  return {
    offsetLeft: 50,
    offsetTop: 30
  }; // default greater viewport
};

var getContent = function getContent(props) {
  var _cleanupClassObject, _cleanupClassObject2;

  var _Object$assign = Object.assign({}, props),
      id = _Object$assign.id,
      className = _Object$assign.className,
      headline = _Object$assign.headline,
      overline = _Object$assign.overline,
      subline = _Object$assign.subline,
      headlineAs = _Object$assign.headlineAs,
      overlineAs = _Object$assign.overlineAs,
      sublineAs = _Object$assign.sublineAs,
      scrollerLabel = _Object$assign.scrollerLabel,
      onScrollerClick = _Object$assign.onScrollerClick,
      hideEyeCatcher = _Object$assign.hideEyeCatcher,
      eyeCatcherText = _Object$assign.eyeCatcherText,
      eyeCatcherTextLong = _Object$assign.eyeCatcherTextLong,
      eyeCatcherIncreaseWidth = _Object$assign.eyeCatcherIncreaseWidth,
      eyeCatcherFontSize = _Object$assign.eyeCatcherFontSize,
      scrollerRef = _Object$assign.scrollerRef,
      layout = _Object$assign.layout,
      layoutRegularRef = _Object$assign.layoutRegularRef,
      layoutBreakingRef = _Object$assign.layoutBreakingRef,
      eyeCatcherPosition = _Object$assign.eyeCatcherPosition,
      eyeCatcherRef = _Object$assign.eyeCatcherRef,
      button = _Object$assign.button;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(hostClass, "-content"), true), _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, getThemeClass("contrast"), true), _cleanupClassObject))
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-eyecatcher"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-eyecatcher__visible"), !hideEyeCatcher), _cleanupClassObject2)),
    style: {
      top: eyeCatcherPosition.top,
      right: eyeCatcherPosition.right,
      bottom: eyeCatcherPosition.bottom,
      left: eyeCatcherPosition.left
    },
    ref: eyeCatcherRef
  }, eyeCatcherText && /*#__PURE__*/React.createElement(EyeCatcherWrapper, {
    text: eyeCatcherText,
    textLong: eyeCatcherTextLong,
    fontSize: eyeCatcherFontSize,
    increaseWidth: eyeCatcherIncreaseWidth
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-content-regular"),
    style: {
      visibility: layout === "regular" ? "visible" : "hidden",
      zIndex: layout === "regular" ? 1 : -1
    },
    ref: layoutRegularRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-title")
  }, /*#__PURE__*/React.createElement(HeadlinePresentation, {
    size: "h1",
    overline: overline,
    subline: subline,
    centeredLayout: true,
    as: layout === "regular" ? headlineAs : "div",
    overlineAs: layout === "regular" ? overlineAs : "div",
    sublineAs: layout === "regular" ? sublineAs : "div"
  }, headline)), button && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-inner-button")
  }, button)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-content-breaking"),
    style: {
      visibility: layout === "breaking" ? "visible" : "hidden",
      zIndex: layout === "breaking" ? 1 : -1
    },
    ref: layoutBreakingRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-title")
  }, /*#__PURE__*/React.createElement(HeadlinePresentation, {
    size: "h1",
    overline: overline,
    centeredLayout: true,
    as: layout === "breaking" ? headlineAs : "div",
    overlineAs: layout === "breaking" ? overlineAs : "div"
  }, headline)), button && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-inner-button")
  }, button)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-content-breaking-full"),
    style: {
      visibility: layout === "breaking-full" ? "visible" : "hidden",
      zIndex: layout === "breaking-full" ? 1 : -1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-title")
  }, /*#__PURE__*/React.createElement(HeadlinePresentation, {
    size: "h1",
    overline: overline,
    centeredLayout: true,
    as: layout === "breaking-full" ? headlineAs : "div",
    overlineAs: layout === "breaking-full" ? overlineAs : "div"
  }, headline)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-scroller"),
    onClick: onScrollerClick,
    ref: scrollerRef,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-scroller-text")
  }, scrollerLabel), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-scroller-icon")
  }, /*#__PURE__*/React.createElement(IconPresentation, {
    icon: interaction_arrows_chevronDown,
    title: "",
    noMargin: true
  }))));
};

var StagePresentation = fComp(function (props) {
  var _cleanupClassObject3, _cleanupClassObject4, _cleanupClassObject5, _cleanupClassObject6;

  var subline = props.subline,
      sublineAs = props.sublineAs,
      theme = props.theme,
      textOutlierTheme = props.textOutlierTheme,
      backgroundVideoSrc = props.backgroundVideoSrc,
      backgroundImageImgSrc = props.backgroundImageImgSrc,
      backgroundImageSource = props.backgroundImageSource,
      backgroundImageFocalPoint = props.backgroundImageFocalPoint,
      viewport = props.viewport,
      noMargin = props.noMargin,
      hostRef = props.hostRef,
      layout = props.layout,
      button = props.button;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, hostClass, true), _defineProperty(_cleanupClassObject3, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject3)),
    ref: hostRef
  }, (backgroundImageSource || backgroundImageImgSrc) && (!backgroundVideoSrc || ["xs"].includes(viewport)) && /*#__PURE__*/React.createElement(PictureBackgroundWrapper, {
    className: cleanupClassObject((_cleanupClassObject4 = {}, _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-background"), true), _defineProperty(_cleanupClassObject4, getThemeClass(theme), !!theme), _cleanupClassObject4)),
    backgroundFocalPoint: getFocalPoint(backgroundImageFocalPoint, viewport),
    imgSrc: backgroundImageImgSrc,
    source: backgroundImageSource
  }, getContent(props)), backgroundVideoSrc && ["xl", "lg", "md", "sm"].includes(viewport) && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject5 = {}, _defineProperty(_cleanupClassObject5, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject5, getThemeClass(theme), !!theme), _cleanupClassObject5))
  }, /*#__PURE__*/React.createElement("video", {
    className: "".concat(hostClass, "-background-video"),
    autoPlay: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: backgroundVideoSrc,
    type: "video/mp4"
  })), getContent(props)), (layout === "breaking-full" || layout === "breaking") && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject6 = {}, _defineProperty(_cleanupClassObject6, "".concat(hostClass, "-outer"), true), _defineProperty(_cleanupClassObject6, getThemeClass(textOutlierTheme), textOutlierTheme), _cleanupClassObject6))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-outer-leadtext")
  }, /*#__PURE__*/React.createElement(ParagraphPresentation, {
    as: sublineAs || "div",
    noMargin: true
  }, subline)), layout === "breaking-full" && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-outer-button")
  }, button)));
}, defaultProps);

export { StagePresentation, defaultProps };
